import { render, staticRenderFns } from "./SportsDataPanel.vue?vue&type=template&id=80d1a75a&scoped=true&"
import script from "./SportsDataPanel.vue?vue&type=script&lang=js&"
export * from "./SportsDataPanel.vue?vue&type=script&lang=js&"
import style0 from "./SportsDataPanel.vue?vue&type=style&index=0&id=80d1a75a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80d1a75a",
  null
  
)

export default component.exports